import React, { useState } from "react";

/**
 * Vimeo embed wrapped in CORSA's 15px rounded "curve" frame.
 * Lazy-loads (only mounts the iframe on first user activation),
 * preserving an aspect-ratio placeholder so layout doesn't shift.
 */
export const VimeoFrame = ({
  src,
  title,
  poster,
  aspect = "16/9", // "16/9" or "9/16"
  className = "",
  dataTestId = "vimeo-frame",
  autoPlayOnActivate = true,
  rounded = 15,
}) => {
  const [active, setActive] = useState(false);

  const aspectStyle = { aspectRatio: aspect.replace("/", " / ") };

  const finalSrc = active
    ? `${src}${src.includes("?") ? "&" : "?"}autoplay=${autoPlayOnActivate ? 1 : 0}`
    : null;

  return (
    <div
      className={`relative w-full curve-frame ${className}`}
      style={{ ...aspectStyle, borderRadius: rounded, background: "#000" }}
      data-testid={dataTestId}
    >
      {!active && (
        <button
          type="button"
          onClick={() => setActive(true)}
          aria-label={`Play ${title || "video"}`}
          data-testid={`${dataTestId}-play`}
          className="absolute inset-0 w-full h-full group"
          style={{ borderRadius: rounded, overflow: "hidden", background: "#000" }}
        >
          {poster && (
            <img
              src={poster}
              alt={title || "Video poster"}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
          )}
          <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/20 transition-colors">
            <span
              className="relative flex items-center justify-center"
              style={{
                width: 72,
                height: 72,
                borderRadius: "9999px",
                background: "var(--calypso)",
                border: "3px solid var(--track)",
                boxShadow: "5px 5px 0 0 var(--track)",
              }}
            >
              <svg width="22" height="26" viewBox="0 0 24 28" fill="var(--track)" aria-hidden="true">
                <path d="M2 2 L22 14 L2 26 Z" />
              </svg>
            </span>
          </div>
        </button>
      )}
      {active && (
        <iframe
          title={title}
          src={finalSrc}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          allowFullScreen
          loading="lazy"
          className="absolute inset-0 w-full h-full"
          style={{ borderRadius: rounded }}
        />
      )}
    </div>
  );
};

export default VimeoFrame;
